export default __webpack_public_path__ + "static/media/roboto-condensed-v18-latin-regular.fd55075a.woff2";